import { render } from "./welcome.vue?vue&type=template&id=543ca630&scoped=true"
const script = {}

import "./welcome.vue?vue&type=style&index=0&id=543ca630&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543ca630"]])

export default __exports__